export default "__VITE_ASSET__GeH5qx5H__"